"use client";

import { Button } from "@/components/ui/button";
import { ArrowRight, Terminal } from "lucide-react";
import { motion } from "framer-motion";
import Link from "next/link";

export function HeroSection() {
  return (
    <section className="relative flex min-h-[85vh] w-full flex-col items-center justify-center overflow-hidden bg-background">
      <div className="absolute inset-0 z-0 h-full w-full bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]"></div>
      <div className="absolute left-0 right-0 top-0 -z-10 m-auto h-[310px] w-[310px] rounded-full bg-primary/20 opacity-20 blur-[100px]"></div>
      <div className="container relative z-10 flex flex-col items-center text-center px-4">
        {/* *** تغییر ۱: اضافه شدن animate-pulse برای چشمک زدن کل بج *** */}
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="mb-6 inline-flex items-center rounded-full border border-white/10 bg-white/5 px-3 py-1 text-sm text-accent backdrop-blur-sm animate-pulse"
        >
          <span className="mr-2 flex h-2 w-2 relative">
             <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent opacity-75"></span>
             <span className="relative inline-flex rounded-full h-2 w-2 bg-accent"></span>
          </span>
          Next-Gen Industrial AI Platform
        </motion.div>
        <motion.h1 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="max-w-4xl text-5xl font-extrabold tracking-tight text-white sm:text-7xl mb-6"
        >
          Injecting <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-accent">Intelligence</span> <br />
          into Industry Veins
        </motion.h1>
        <motion.p 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="max-w-2xl text-lg text-muted-foreground mb-10 leading-relaxed"
        >
          Transforming traditional industries with enterprise-grade AI solutions. 
          From predictive maintenance in oil rigs to fraud detection in banking.
        </motion.p>
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.6 }}
          className="flex flex-col sm:flex-row gap-4 w-full justify-center"
        >
          {/* *** تغییر ۲: این دکمه‌ها قبلا لینک شده بودند، از صحت آنها اطمینان حاصل می‌کنیم *** */}
          <Button size="lg" asChild className="bg-primary hover:bg-primary/90 text-white min-w-[160px] h-12 text-base group">
            <Link href="/contact">
              Start Your Journey
              <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </Button>
          <Button size="lg" variant="secondary" asChild className="min-w-[160px] h-12 text-base border border-white/5 hover:bg-white/5">
            <Link href="/projects">
              <Terminal className="mr-2 h-4 w-4" />
              View Solutions
            </Link>
          </Button>
        </motion.div>
      </div>
    </section>
  );
}